
import './App.css';
import Home from './Components/home';
import { Routes, Route, useLocation } from "react-router-dom";
import PrivacyPolicy from './Components/privacyPolicy';
import TermsAndCondition from './Components/TermsAndCondition'; 
import { useEffect } from 'react';

function App() {
  const ScrollToTop = () => {
    const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  
    return null;
  };
  
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-condition" element={<TermsAndCondition />} /> 
      </Routes>
    </div>
  );
}

export default App;

